import { render, staticRenderFns } from "./DeleteMember.vue?vue&type=template&id=03e8d365"
import script from "./DeleteMember.vue?vue&type=script&lang=js"
export * from "./DeleteMember.vue?vue&type=script&lang=js"
import style0 from "./DeleteMember.vue?vue&type=style&index=0&id=03e8d365&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports